export const isOperator = () => {
    let element = document.getElementById('udesk_qa_web');
    let res = false;
    if (element && element.hasAttribute('operator') && element.getAttribute('operator') === 'true') {
        res = true;
    }
    element = null;

    return res;
};